<template>

    <div class="discover-article marginb20" >
        <div class="flex-container marginl30" :style="'padding-top:'+pt+'px;'+(role == 'his'?'align-items:flex-start;margin-right:15px;':'')">
            <div class="pos-r float-left marginr30" style="width:60px;height:60px" @click="changeAvatar">
                <div class="border-round" style="width:60px;height:60px;overflow: hidden;">
                    <img alt="" width="100%" class="" :src="data.imageUrl||'//image1.51tiangou.com/tgou2/img2/fitting/defaultPic.jpg'">
                </div>
                <div class="member bg-red pos-a border-round text-center right0 bottom0" v-show="data.roleType == 4">
                    <!-- <i class="icon-pd_crown text-white text-white"></i> -->
                </div>
            </div>
            <div class="flex1">
                <div style="overflow: hidden" class="flex-container">
                    <div class="flex1">
                        <a href="/mine/nickname.html" v-if="role != 'his'"><div class="float-left"><p class="fs-14 paddingr10">{{data.name}}</p></div></a>
                        <div class="float-left"  v-if="role == 'his'"><p class="fs-14 paddingr10">{{data.name}}</p></div>
                        <div class="text-red fs-11" style="padding:2px 3px 0;overflow: hidden;width:42px;" v-show="data.roleType == 4">
                            <i class="icon-discover_daren" style="font-size: 10px;"> </i><span>官方</span>
                        </div>
                    </div>
                    <div class="badge badge-big badge-pill fs-15"
                         :class="{'badge-red':!data.hasConcerned,'badge-light':data.hasConcerned}"
                         @click="concern(data.memberId, data.hasConcerned, data)"
                         v-show="role == 'his'">
                        <span class="icon-add fs-12 lh-12 dis-i float-left" v-show="role == 'his' && !data.hasConcerned"></span>
                        <span class="dis-i float-left paddingl10 fs-12" style="line-height: 14px;" v-show="role == 'his' && !data.hasConcerned">关注</span>
                        <span class="dis-i fs-12" style="line-height: 14px;width:41px;" v-show="role == 'his' && data.hasConcerned">已关注</span>
                    </div>
                </div>
                <div style="background: none" class="fs-15 margint20 flex-container" v-show="role == 'his'">
                    <div class="flex1">
                        <div style="padding:4px 10px;background-color:rgba(255,74,74,.1);border-radius: 5px;" class="clearfix float-left" v-text="data.desc" v-show="data.desc">
<!--                            <div class="clearfix float-left text-red">-->
<!--                                <span class="icon-discover_eye fs-13 dis-i float-left full" style="line-height:16px;"></span>-->
<!--                                <span class="fs-13 dis-i float-left" style="padding-left:4px;line-height: 16px;">{{data.browseNum}}</span>-->
<!--                            </div>-->
<!--                            <div class="clearfix float-left text-red" style="margin-left:40px;">-->
<!--                                <span class="icon-counter_like fs-13 dis-i float-left text-red full" style="line-height:16px;"></span>-->
<!--                                <span class="fs-13 dis-i float-left" style="padding-left:4px;line-height: 16px;">{{data.likedNum}}</span>-->
<!--                            </div>-->
                        </div>
                    </div>
                    <div class="badge badge-orange badge-big badge-pill fs-15 marginl20"
                         v-if="isWeixin">
                        <div class="clearfix">
                            <span class="icon-chat fs-12 lh-12 dis-i float-left"></span>
                            <span class="dis-i float-left paddingl10 fs-12" style="line-height: 14px;" v-on:click="chat(data.memberId)">聊聊</span>
                        </div>
                    </div>
                </div>
                <div style="margin-top:12px;" class="" v-show="role != 'his'">
                    <div style="padding:4px 10px;background-color:rgba(255,74,74,.1);border-radius: 5px;" class="clearfix float-left">
                        <div class="clearfix float-left text-red">
                            <span class="icon-discover_eye fs-13 dis-i float-left full" style="line-height:16px;"></span>
                            <span class="fs-13 dis-i float-left" style="padding-left:4px;line-height: 16px;">{{data.browseNum}}</span>
                        </div>
                        <div class="clearfix float-left text-red" style="margin-left:40px;">
                            <span class="icon-counter_like fs-13 dis-i float-left text-red full" style="line-height:16px;"></span>
                            <span class="fs-13 dis-i float-left" style="padding-left:4px;line-height: 16px;">{{data.likedNum}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex-container pos-r bg-white" style="height:60px;margin-top:30px;">
            <div class="span6 text-center ">
                <p class="fs-20 text-dark">{{data.discoverNum}}</p>
                <p class="fs-12 text-dark">已发布</p>
            </div>
<!--            <a href="/discover/myConcern.html?memberId={{data.memberId}}" class="span4 text-center ">-->
<!--                <div>-->
<!--                    <p class="fs-20 text-dark">{{data.watchNum}}</p>-->
<!--                    <p class="fs-12 text-dark">关注</p>-->
<!--                </div>-->
<!--            </a>-->
            <a href="/discover/myFans.html?memberId={{data.memberId}}" class="span6 text-center ">
                <div >
                    <p class="fs-20 text-dark">{{data.fansNum}}</p>
                    <p class="fs-12 text-dark">粉丝</p>
                </div> 
            </a>

        </div>
    </div>

</template>

<script>
export default {
    props:{
        data:{
            type: Object,
            default: null
        },
        role:{
            type: String,
            default: null
        }
        , isWeixin: {
            type: Boolean
            , default: true
        }
    },
    computed:{

    },
    ready:function(){

    },
    data:function(){
        return {
            pt:(maple.cookie('hybrid') === 'true')?75:55
        }
    },
    methods: {
        chat(memberId){
            this.$dispatch('chat', memberId)
        }
        , changeAvatar(){
        	this.$dispatch('changeAvatar');
        }        
        , concern: function(memberId, hasConcerned, data){
            if( hasConcerned ){
                this.$dispatch('notConcernEvent', memberId, data);
            }
            else{
                this.$dispatch('concernEvent', memberId, data);
            }
        }
    }
}
</script>

<style lang="scss">

</style>